export function disableMap(map) {
  if ('ontouchstart' in window) {
    map.dragging.disable();
    if (map.tap) map.tap.disable();
  }

  const mapNode = document.getElementById('map');

  map.doubleClickZoom.disable();
  map.scrollWheelZoom.disable();
  map.boxZoom.disable();
  map.keyboard.disable();
  if (mapNode) mapNode.style.cursor = 'default';
}

export function enableMap(map) {
  if ('ontouchstart' in window) {
    map.dragging.enable();
    // if (map.tap) map.tap.enable();
  }

  const mapNode = document.getElementById('map');

  map.doubleClickZoom.enable();
  map.scrollWheelZoom.enable();
  map.boxZoom.enable();
  map.keyboard.enable();
  if (mapNode) mapNode.style.cursor = 'grab';
}

export default {
  disableMap,
  enableMap
};